// extracted by mini-css-extract-plugin
export default {"h1":"Basket_h1__X5+D0","items":"Basket_items__kjcLm"};